import React, { useContext, useState } from "react";
import SystemModal from "../Common/SystemModal";
import ajaxRequisitions from "../../util/remote/ajaxRequisitions"; // make sure this exists
import toast, { Toaster } from "react-hot-toast";
import AuthContext from "../../Context/AuthContext";
import ajaxApprovals from "../../util/remote/ajaxApprovals";
const RequisitionDetailsApproverModal = ({ data, funct }) => {
  const { userId } = useContext(AuthContext);
  const [comment, setComment] = useState("");
  const [rejectedItemIDs, setRejectedItemIDs] = useState([]);
  const [loading, setLoading] = useState(false);
  // ---- org defaults ----
  const orgInfo = {
    name: "LA_PROCURE AFRICA LIMITED",
    lines: [
      "P.O.BOX 28775 KAMPALA",
      "PLOT 79B BOMBO ROAD",
      "TEL: +256701666160",
      "EMAIL: info@laprocure.africa",
    ],
    logoSrc: `${process.env.PUBLIC_URL}/assets/img/brand/icon-light.png`,
    watermarkSrc: `${process.env.PUBLIC_URL}/assets/img/brand/icon-light.png`,
  };
  // toggle reject selection
  const toggleReject = (id) => {
    setRejectedItemIDs((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };
  const handleSubmit = async (e, controls) => {
    const payload = {
      approverID: userId,
      reqID: data.id,
      comment: comment,
      date_created: new Date().toISOString().split("T")[0],
      rejectedItemIDs: rejectedItemIDs,
    };
    setLoading(true);
    const response = await ajaxApprovals.createApproval(payload);
    setLoading(false);
    if (response.status === "OK") {
      funct();
      //   window.alert("Approval level updated successfully");
      toast.success("Approval level updated successfully");
      controls.close();
    } else {
      toast.error(response.message);
    }
  };
  const RenderFooter = (controls) => (
    <>
      <button
        className="btn ripple btn-dark"
        type="button"
        onClick={controls.close}
      >
        Cancel/Close
      </button>
      <button
        className="btn ripple btn-success"
        type="button"
        onClick={(e) => handleSubmit(e, controls)}
      >
        Submit Approval
      </button>
    </>
  );
  return (
    <SystemModal
      title="Requisition Details"
      id="model-requisition"
      size="xl"
      footer={RenderFooter}
    >
      <style>{baseStyles(orgInfo.watermarkSrc)}</style>
      <Toaster />
      <div id="printablediv">
        <div className="doc">
          <div className="doc-content">
            {/* Header */}
            <div className="doc-header">
              <div className="logo-wrap">
                <img src={orgInfo.logoSrc} alt="Logo" />
              </div>
              <div className="org-text">
                <div className="org-name">{orgInfo.name}</div>
                {orgInfo.lines.map((l, i) => (
                  <div key={i} className="org-line">
                    {l}
                  </div>
                ))}
              </div>
            </div>
            <div className="title">MATERIAL REQUISITION FORM</div>
            {/* Meta table */}
            <table className="meta">
              <tbody>
                <tr>
                  <td>
                    <b>Date:</b> {data.date_created}
                  </td>
                  <td>
                    <b>Requisition ID:</b> {data.id}
                  </td>
                  <td>
                    <b>Status:</b>
                    {data.status === "1" ? "Approved" : "Pending"}
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>Department:</b> {data.department}
                  </td>
                  <td>
                    <b>Prepared By:</b> {data.first_name} {data.last_name}
                  </td>
                  <td>
                    <b>Estimated Total:</b> {data.est_total}
                  </td>
                </tr>
                <tr>
                  <td colSpan="3">
                    <b>Narration:</b> {data.naration}
                  </td>
                </tr>
              </tbody>
            </table>
            {/* Comment Box */}
            <div className="mt-3">
              <label>
                <b>Approver Comment:</b>
              </label>
              <textarea
                style={{ border: "2px solid black" }}
                className="form-control"
                rows="3"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />
            </div>
            {/* Items with Reject checkbox */}
            <table className="items">
              <thead>
                <tr>
                  <th>Reject?</th>
                  <th style={{ width: "70px" }}>Stock #</th>
                  <th>Item Description</th>
                  <th style={{ width: "90px" }}>Unit</th>
                  <th style={{ width: "90px" }}>Qty</th>
                  <th style={{ width: "130px" }}>Est. Unit cost</th>
                  <th style={{ width: "130px" }}>Actual Cost</th>
                  <th style={{ width: "130px" }}>SubTotal</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(data.items) && data.items.length > 0 ? (
                  data.items.map((it, idx) => (
                    <tr key={it.id}>
                      <td>
                        <input
                          type="checkbox"
                          checked={rejectedItemIDs.includes(it.id)}
                          onChange={() => toggleReject(it.id)}
                        />
                      </td>
                      <td>{idx + 1}</td>
                      <td>{it.item_name}</td>
                      <td>{it.unit}</td>
                      <td>{it.quantity}</td>
                      <td>{it.est_unit_cost}</td>
                      <td>{it.actual_cost ?? "-"}</td>
                      <td>{it.sub_total ?? "-"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" style={{ textAlign: "center" }}>
                      No items
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {/* Totals */}
            <div className="totals">
              <table>
                <tbody>
                  <tr>
                    <td>
                      <b>Estimated Total</b>
                    </td>
                    <td>{data.est_total}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>Real Total</b>
                    </td>
                    <td>{data.real_total ?? "-"}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            {/* Signature */}
          </div>
          <div className="footer-print">
            Approved on: {new Date().toLocaleString()}
          </div>
        </div>
      </div>
    </SystemModal>
  );
};
// shared CSS for preview + print (watermark via ::before so opacity works)
const baseStyles = (watermarkSrc) => `
  * { box-sizing: border-box; }
  body { font-family: Arial, sans-serif; }
  .doc {
    position: relative;
    padding: 18mm 15mm;
    min-width: 210mm;
    max-width: 210mm; /* A4 width */
    margin: 0 auto;
    background: #fff;
    border: 1px solid #e5e7eb;
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }
  .doc::before {
    content: "";
    position: absolute;
    inset: 0;
    background: url("${watermarkSrc}") no-repeat center center; !important
    background-size: 60%;
    opacity: 0.2; /* 👈 control watermark opacity here */
    z-index: 0;
  }
  .doc-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 1; /* ensures content stays above watermark */
  }
  .doc-header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 8px;
    position: relative;
    z-index: 2;
  }
  .logo-wrap img { width: 180px; height: 180px; object-fit: contain; }
  .org-text { flex: 1; text-align: center; }
  .org-name { font-size: 20px; font-weight: 700; letter-spacing: .5px; }
  .org-line { font-size: 12px; line-height: 1.2; }
  .title {
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    margin: 6px 0 10px 0;
    position: relative; z-index: 2;
  }
  table { border-collapse: collapse; width: 100%; margin-top: 10px; position: relative; z-index: 2; }
  th, td { border: 1px solid #111; padding: 6px 8px; font-size: 12.5px; vertical-align: top; }
  th { background: #f2f2f2; text-align: left; }
  .meta { margin-bottom: 12px; }
  .meta td { border: 1px solid transparent; padding: 4px 0; font-size: 13px; }
  .meta tr td:first-child, .meta tr td:nth-child(2), .meta tr td:nth-child(3) { border: none; }
  .items th:nth-child(4) { width: 40%; }
  .totals { margin-top: 16px; width: 260px; }
  .totals td:first-child { width: 60%; }
  .signature { margin-top: auto; }
  .signature .line { margin-top: 16px; border-bottom: 1px solid #111; width: 60%; height: 20px; }
  .footer-print { margin-top: 18px; font-size: 11px; text-align: right; color: #374151; position: relative; z-index: 2; }
  @page { size: A4; margin: 12mm; }
`;
export default RequisitionDetailsApproverModal;
